import { SELECTED_PICKING_CHANGED } from '../actions/picking.actions'

const initialPickingState = {
  selectedPicking: null,
}

export default function (state = initialPickingState, action) {
  switch (action.type) {
    case SELECTED_PICKING_CHANGED:
      return {
        ...state,
        selectedPicking: action.picking,
      }
    default:
      return state
  }
}
